import { Page, Layout, LegacyCard, Collapsible, TextContainer, Icon, LegacyStack, Button, Text, Pagination } from '@shopify/polaris';
import React, { useState, useCallback, useEffect } from 'react';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import { ChevronDownIcon, ChevronUpIcon } from '@shopify/polaris-icons';
import { FetchCustom } from './FetchCustom';
import { useHostNavigate } from "../hooks";

export function Announcements(props) {
    const navigate = useHostNavigate();

    const [loading, setLoading] = useState(true);
    const [model, setModel] = useState({});
    const [redirectUrl, setRedirectUrl] = useState('');

    const fetch = FetchCustom();

    const populateData = async (pageNumber) => {
        props.setIsLoading(true);
        const data = await fetch('api/home/announcements' + (pageNumber ? "?pageNumber=" + pageNumber : ""));

        if (data.reauthorizeUrl) {
            return;
        }

        props.setIsLoading(false);

        if (data.redirectUrl) {
            setRedirectUrl(data.redirectUrl);
        }
        else {
            setModel(data);
            setLoading(false);
        }
    };

    const getUser = async () => {
        if (!props.userLoaded) {
            props.setUserLoaded(true);
            const data = await fetch('api/home/userInfo');

            if (data.redirectUrl) {
                setRedirectUrl(data.redirectUrl);
            }
            else if (JSON.stringify(props.user) !== JSON.stringify(data)) {
                props.setUser(data);
                localStorage.setItem('user', JSON.stringify(data));
            }
        }
    };

    const readAnnouncement = async (id) => {
        await fetch('api/home/readAnnouncement', { id: id });
        //props.unreadAnnouncementsCount();
    };

    const handlePageChange = useCallback(
        (value) => {
            populateData(model.pageNumber + value);
        },
        // eslint-disable-next-line
        [model],
    );

    const handleExpand = useCallback(
        (index, id) => {
            if (!model.items[index].expanded && !model.items[index].read) {
                readAnnouncement(id);
            }

            setModel((prevState) => {
                let model = Object.assign({}, prevState);
                model.items[index].expanded = !model.items[index].expanded;
                model.items[index].read = true;
                return model;
            });
        },
        // eslint-disable-next-line
        [model],
    );

    useEffect(() => {
        document.title = "Notifications | Stack Discounts";
        populateData();
        getUser();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (redirectUrl) {
            navigate(redirectUrl);
        }
    }, [redirectUrl, navigate]);

    return (
        loading ?
            <SkeletonPageCustom />
            :
            <Page title="Notifications">
                <Layout>
                    {
                        model.items.map((item, index) => {
                            return <Layout.Section key={index}>
                                {
                                    <LegacyCard>
                                        <div className="notification-header" onClick={() => { handleExpand(index, item.id) }}>
                                            <div className={'notification-status' + (item.read ? '' : ' unread')}></div>
                                            <div className="notification-title">
                                                <Text variant="headingMd" as="h2" tone={(item.read ? "subdued" : "")}>{item.title}</Text>
                                                <Text as="span" tone="subdued">{item.dateString}</Text>
                                            </div>
                                            <div className="notification-icon">
                                                {
                                                    item.expanded ? <Icon source={ChevronUpIcon} /> : <Icon source={ChevronDownIcon} />
                                                }
                                            </div>
                                        </div>
                                        <Collapsible
                                            open={item.expanded}
                                            expandOnPrint
                                        >
                                            <div className="notification-content">
                                                <TextContainer>
                                                    {item.content}
                                                </TextContainer>
                                                {
                                                    item.url ?
                                                        <Button onClick={() => { window.open(item.url, '_blank'); }}>{item.linkTitle ? item.linkTitle : "Learn more"}</Button>
                                                        : null
                                                }

                                            </div>
                                        </Collapsible>
                                    </LegacyCard>
                                }
                            </Layout.Section>
                        })
                    }
                    <Layout.Section>
                        <LegacyStack distribution="center">
                            <Pagination
                                hasPrevious={model.hasPreviousPage}
                                onPrevious={() => { handlePageChange(-1); }}
                                hasNext={model.hasNextPage}
                                onNext={() => { handlePageChange(1); }}
                            />
                        </LegacyStack>
                    </Layout.Section>
                </Layout>
            </Page >
    );
}